import { useAuthentication } from '@/hooks/useAuthentication';
import { useEffect } from 'react';
import Smartlook from 'smartlook-client';

function SmartlookSH() {
  const result = useAuthentication();

  useEffect(() => {
    const isProd = import.meta.env.VITE_API_URL === 'https://cms.app.stillhuman.co.uk';

    if (!isProd || Smartlook.initialized()) {
      return;
    }

    console.log('Smartlook init');
    Smartlook.init('0f3efb78ed2c3cbde86c8574da6ad27705eaf108');
  }, []);

  useEffect(() => {
    if (!Smartlook.initialized()) {
      console.log(`Smartlook can't identify with uninitialized client`);
      return;
    }

    const user = result?.authentication?.user;

    if (!user) {
      return;
    }

    Smartlook.identify(`user_${user?.email}`, {
      user_id: user?.id?.toString(),
      user_name: user?.forename + ' ' + user?.surname || '-',
      school_id: user?.school?.id,
      school_name: user?.school?.name,
      role: user?.profile || '-',
    });
  }, [result?.authentication?.user]);

  return <></>;
}

export default SmartlookSH;
